import { Typography } from '@material-ui/core'
import Button from '@material-ui/core/Button'
import React, { FC } from 'react'

import { useStyles } from './BulkActivateDeactivateDialog.styles'
import { SelectedListing } from './BulkActivateDeactivateDialog.types'

type ConfirmContentProps = {
    eligible: SelectedListing[]
    skip: SelectedListing[]
    target: string
    isActivate: boolean
    showList: boolean
}

export const ConfirmContent: FC<ConfirmContentProps> = ({ eligible, skip, target, isActivate, showList }) => {
    const classes = useStyles()
    return (
        <>
            <Typography variant="body2">
                This will set{' '}
                <strong>
                    {eligible.length} product{eligible.length === 1 ? '' : 's'}
                </strong>{' '}
                to <strong>{target}</strong>. Please Confirm.
                {/* TODO #2680113: verify if description text is needed */}
            </Typography>
            {skip.length > 0 && (
                <Typography className={classes.skipNote}>
                    {skip.length} product{skip.length === 1 ? '' : 's'} already{' '}
                    {target.toLowerCase()} — will be skipped.
                </Typography>
            )}
            {showList && (
                <ul className={classes.listContainer} aria-label="Products in this action">
                    {eligible.map((p) => (
                        <li key={p.listingId} className={classes.listRow}>
                            <span>{p.productName}</span>
                            <span className={p.isActive ? classes.statusActive : classes.statusInactive}>
                                {p.isActive ? 'Active' : 'Inactive'}
                            </span>
                        </li>
                    ))}
                    {skip.map((p) => (
                        <li key={p.listingId} className={`${classes.listRow} ${classes.listRowSkip}`}>
                            <span>{p.productName}</span>
                            <span className={classes.skipLabel}>skip</span>
                        </li>
                    ))}
                </ul>
            )}
        </>
    )
}

type ConfirmActionsProps = {
    onClose: () => void
    onConfirm: () => void
    eligible: SelectedListing[]
    isActivate: boolean
    verb: string
}

export const ConfirmActions: FC<ConfirmActionsProps> = ({ onClose, onConfirm, eligible, isActivate, verb }) => {
    const classes = useStyles()
    return (
        <>
            <Button onClick={onClose} variant="text" className={classes.cancelButton}>
                Cancel
            </Button>
            <Button
                onClick={onConfirm}
                disabled={eligible.length === 0}
                variant="contained"
                color={isActivate ? 'primary' : 'secondary'}
                style={!isActivate ? { backgroundColor: '#D32F2F', color: '#fff' } : undefined}
            >
                {verb} {eligible.length} {eligible.length === 1 ? 'product' : 'products'}
            </Button>
        </>
    )
}
